import {Link} from 'react-router-dom';

export default function Foot(){
    return(
        <div className="footer">
            <div className="content">
                <div className="foot">
                    <h3>Ijtimoiy tarmoqlar</h3>
                    <nav className="effect"></nav>
                    <ul className='messenger-list'>
                        <li><a href="/"><i className='fa fa-paper-plane cltg'></i>Telegram</a></li>
                        <li><a href="/"><i className='fa fa-twitter cltwitter'></i>Twitter</a></li>
                        <li><a href="/"><i className='fa fa-facebook clfacebook'></i>Facebook</a></li>
                        <li><a href="/"><i className='fa fa-instagram clinsta'></i>Instagram</a></li>
                        <li><a href="/"><i className='fa fa-youtube clyoutube'></i>Youtube</a></li>
                    </ul>
                </div>
                <div className="foot">
                    <h3>Bizning manzil</h3>
                    <nav className="effect"></nav>
                    <ul className='messenger-list'>
                        <li><a><i className='fa fa-map-marker cltg'></i>103, Taraqqiyot ko'chasi, Toshkent .sh</a></li>
                        <li><a><i className='fa fa-phone clfacebook'></i>+998(91 151-31-17)</a></li>
                        <li><a><i className='fa fa-fax cltwitter'></i>+998(91 151-31-17)</a></li>
                        <li><a><i className='fa fa-envelope clfax'></i>info@tsdi.uz</a></li>
                        <li><a><i className='fa fa-globe cltg'></i>www.tsdi.uz</a></li>
                    </ul>
                </div>
                <div className="foot">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d20120.112689896025!2d69.296945!3d41.310068!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x41490626bc752d26!2sToshkent%20davlat%20stomatologiya%20instituti%20eski!5e1!3m2!1sen!2sus!4v1671468313818!5m2!1sen!2sus" width="100%" height="250" frameborder="0" style={{border:0}} allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                </div>
                </div>
                <div className="content">
                <p className="alert">Barcha huquqlar himoyalangan. Saytdagi barcha huquqlar O'zbekiston Respublikasi qonunlariga, shu jumladan mualliflik huquqi va turdosh huquqlarga muvofiq himoya qilinadi. Sayt materiallaridan foydalanganda, Toshkent davlat stomatologiya instituti saytiga havola ko'rsatilishi shart. Diqqat! Agar siz matnda xatoliklarni aniqlasangiz, ularni belgilab, web sayt ma'murini xabardor qilish uchun biz bilan bog'lanishingizni so'raymiz</p>
            </div>
      </div>
    )
}